<template>
	<div class="list-wrapper">
		<div class="list-item" v-for="item in data">
			<div class="item-content" @click="todetail(item.id)">
				<div class="title">{{item.title}}</div>
				<div class="abstrc" style="-webkit-box-orient: vertical;">{{item.description}}</div>
				<div class="create" >
					<span class="username">{{item.creatorNickname}}</span>
					<span class="publishDate">{{item.createDate}}</span>
					<span class="readNum"><i class="iconfont icon-chakan"></i>{{item.readNum>1000?item.readNum>10000?(item.readNum/10000).toFixed(1)+'w':(item.readNum/1000).toFixed(1)+'k':item.readNum}}</span>
				</div>
			</div>
			<div class="image-wrapper">
				<el-image :src="item.descImages" fit="fill">
					<div slot="error" class="image-slot">
						<i class="el-icon-picture-outline"></i>
					</div>
				</el-image>
			</div>
		</div>
		<el-pagination
			:hide-on-single-page="true"
		    layout="prev, pager, next"
			@current-change="handleCurrentChange"
		    :total="total">
		  </el-pagination>
		<el-empty v-if="total == 0" :image-size="200"></el-empty>
	</div>
</template>

<script>
import { getDraftList } from '@/api/personal/user'
export default {
  data () {
    return {
      data:[],
	  page: 1,
	  total: 0
    }
  },
  methods: {
    async getList(){
    	const res = await getDraftList({page:this.page,limit:10,isRelease:'0'})
    	if (res.code === 0) {
    		this.data = res.data.list
			this.total = res.data.total
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	handleCurrentChange(val){
		this.page = val
		this.getList()
	},
	getDifferTime(date){
		var publishDate = new Date(date)  
		var currentDate = new Date()  
		if(publishDate.getFullYear()<currentDate.getFullYear()){
			if(currentDate.getFullYear()-publishDate.getFullYear()==1){
				if(publishDate.getMonth() == currentDate.getMonth()){
					return '发布于1年前'
				}else{
					return `发布于${12-publishDate.getMonth()+currentDate.getMonth()}月前`
				}
			}else{
				return '发布于1年前'
			}
			
		}else{
			if(publishDate.getMonth() == currentDate.getMonth()){
				if(publishDate.getDate() == currentDate.getDate()){
					return `发布于${currentDate.getHours()- publishDate.getHours()}小时前`
				}else{
					return `发布于${currentDate.getDate()- publishDate.getDate()}日前`
				}
			}else{
				return `发布于${currentDate.getMonth()-publishDate.getMonth()}月前`
			}
		}
	},
	todetail(id){
		this.$router.push({path:'/social/detail/'+id})
	},
  },
  mounted () {
	this.getList()  
  }

}
</script>

<style lang="scss" scoped>
.list-wrapper{
	padding: 0 10px;
	.list-item{
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 15px;
		margin-top: 15px;
		cursor: pointer;
		.item-content{
			display: inline-block;
			width: calc(100% - 200px);
			vertical-align: top;
			.abstrc{
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: normal;
			}
			.title{
				font-size: 18px;
				font-weight: 800;
				color: #292929;
				margin: 0 0 10px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				&:hover{
					opacity: .82;
				}
			}
			.abstrc{
				font-size: 16px;
				color: #596372;
			}
			.create{
				color: #A1A7B0;
				font-size: 14px;
				margin-top: 8px;
				span{
					margin-right: 30px;
				}
				.username{
					color: #596372;;
				}
				.readNum{
					.iconfont{
						margin-right: 5px;
					}
				}
			}
		}
		
	}
	.image-wrapper{
		display: inline-block;
		margin-left: 30px;
		.el-image{
			width: 170px;
			height: 120px;
			border-radius: 5px;
		}
	}
	/deep/.el-image__error{
		height: 100px;
	}
	

}	

</style>